import { useState } from 'react';
import { Palette } from 'lucide-react';
import { useAuth } from '../store/auth';

const themes: { value: string; label: string; color: string }[] = [
  { value: 'cyberpunk-dark', label: 'Cyberpunk Dark', color: '#00ffe1' },
  { value: 'cyberpunk-neon', label: 'Cyberpunk Neon', color: '#ff2bd6' },
  { value: 'cyberpunk-mono', label: 'Cyberpunk Mono', color: '#39ff14' },
  { value: 'light', label: 'Light', color: '#94a3b8' },
];

export function ThemeSwitcher() {
  const [open, setOpen] = useState(false);
  const { user, setTheme } = useAuth();
  const current = user?.themePreference ?? 'cyberpunk-dark';

  return (
    <div className="relative">
      <button
        onClick={() => setOpen((s) => !s)}
        className="flex items-center gap-2 px-3 py-1.5 rounded-sm border border-border-subtle hover:border-neon-cyan text-text-secondary hover:text-neon-cyan transition-all text-xs uppercase font-display tracking-wider"
      >
        <Palette size={14} />
        Theme
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-10" onClick={() => setOpen(false)} />
          <div className="absolute right-0 top-full mt-1 z-20 cyber-panel py-1 min-w-[180px] animate-fade-in">
            {themes.map((t) => (
              <button
                key={t.value}
                onClick={() => {
                  setTheme(t.value);
                  setOpen(false);
                }}
                className={`w-full flex items-center gap-3 px-3 py-2 text-sm hover:bg-bg-tertiary transition-colors ${
                  current === t.value ? 'text-neon-cyan' : 'text-text-secondary'
                }`}
              >
                <span
                  className="w-3 h-3 rounded-sm border border-white/20"
                  style={{ background: t.color }}
                />
                {t.label}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
